import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";

export default function NotFound() {
  return (
    <div className="paper-bg" data-testid="not-found-page">
      <PublicNav />
      <section className="max-w-[880px] mx-auto px-6 md:px-10 py-28 md:py-40 text-center">
        <div className="label-uppercase text-[#7D2E3F] mb-6">Errore 404</div>
        <h1 className="font-serif text-6xl md:text-7xl leading-[0.95] text-[#3A3D42]">
          Questa pagina<br /> non è più in Galleria.
        </h1>
        <p className="text-[#5C5657] mt-8 max-w-xl mx-auto leading-relaxed">
          L'indirizzo che hai seguito non porta a nessuna scheda del Protocollo. Può essere stato
          rimosso, spostato, oppure non essere mai esistito. Torna alla Galleria o riparti dalla
          home per orientarti.
        </p>
        <div className="mt-12 flex flex-wrap gap-4 justify-center">
          <Link to="/" data-testid="notfound-home" className="btn-primary">Torna alla Home</Link>
          <Link to="/galleria" data-testid="notfound-galleria" className="btn-secondary">Vai alla Galleria</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
